<script lang="ts">
import { Icon, Input, InputGroup } from "sveltestrap";
import AppWraper from "../components/AppWraper.svelte";
import MapView from "../components/MapView.svelte";
import { CENTERCOORDS } from '../evironment';
import type { Coords } from "../interfaces";
import { diligencesService, directionsService, thirdsService } from "../services";
import type { Diligence } from '../Model/Diligence';
import type { Direction } from "../Model/Direction";
import UserMarker from "../components/UserMarker.svelte";
import { onMount } from "svelte";
import type { Third } from "../Model/Third";

let centerCoords: Coords = {
  lat: CENTERCOORDS.lat,
  lon: CENTERCOORDS.lon
}

let colorDiligence = 'rgb(5, 129, 237)';
let colorThirdDirection = '#BB2C3A';

let searchFilterDiligence = null;
let searchFilterThird = null;
    
let offset = 0;
let limit = 25;
let mapListMap = new Map();

let thirds: Third[];
let thirdsDirection: Direction[] = [];
let thirdsToMap: Direction[];

let diligences: Diligence[];
let diligencesToMap: Diligence[];

onMount(() => {
  loadDiligence();
  loadThird();
})


async function loadDiligence(){

  diligences = [];

  let opts = {
      offset : offset,
      limit : limit,
      filters : {
          search: searchFilterDiligence
      }
  }
                  
  diligences = await diligencesService.findDiligences(opts);

  chargeMapDiligence()

}

async function loadThird(){

  let opts = {
      offset : offset,
      limit : limit,
      filters : {
          search: searchFilterThird
      }
  }

  thirds = await thirdsService.findThirds(opts);

  thirdsDirection = await Promise.all(thirds.map(({addressId}) => directionsService.findOne(addressId)));

  chargeMapThird()

}

function chargeMapDiligence(){

  if (mapListMap.has('diligence')) {
    let diligencesMap = mapListMap.get('diligence');

    for (const diligence of diligences) {
      if (!diligencesMap.find(d => d.id == diligence.id)) {
        diligencesMap.push(diligence);
      }
    }

    mapListMap.set('diligence', diligencesMap);

  }else{
    mapListMap.set('diligence', diligences);
  }

  diligencesToMap = mapListMap.get('diligence');
  
}


function chargeMapThird(){

  if (mapListMap.has('third')) {
    let thirdsMap = mapListMap.get('third');

    for (const third of thirdsDirection) {
      if (!thirdsMap.find(d => d.id == third.id)) {
        thirdsMap.push(third);
      }
    }

    mapListMap.set('third', thirdsMap);

  }else{
    mapListMap.set('third', thirdsDirection);
  }

  thirdsToMap = mapListMap.get('third');

}

</script>


<AppWraper>
  <div class="container-fluid mt-3 me-5">
    <div class="container mb-3">
      <div class="col-12 col-sm-9 mb-3">
        <div class="text-start">
            <h3>Datos en mapa</h3>
        </div>
      </div>
      <div class="row border rounded mt-3">
        <div class="col-12 col-md-3 mt-2 mb-3">
          <InputGroup>
            <Input placeholder="Encuentra una diligencia" bind:value={searchFilterDiligence} />
            <button type="submit" class="btn btn-primary" on:click={loadDiligence}><Icon name="search" /></button>
          </InputGroup>
        </div>
        <div class="col-12 col-md-3 mt-2 mb-3">
          <InputGroup>
            <Input placeholder="Encuentra un tercero" bind:value={searchFilterThird} />
            <button type="submit" class="btn btn-danger" on:click={loadThird}><Icon name="search" /></button>
          </InputGroup>
        </div>
        <div class="col-12 mt-2 mb-3">
            <div class="col-12">
                <div class="map-view-container mb-3">
                    <MapView center={centerCoords}>
                      {#each diligencesToMap as diligence}
                          {#if diligence.coords}
                            <UserMarker bind:location={diligence.coords} color={colorDiligence} />
                          {/if}
                      {/each}
                      {#each thirdsToMap as thirdDirection}
                          {#if thirdDirection.coords}
                            <UserMarker bind:location={thirdDirection.coords} color={colorThirdDirection} />
                          {/if}
                      {/each}
                    </MapView>
                </div>
            </div>
        </div>

      </div>
    </div>



  </div>
  </AppWraper>
  
  
  <style lang="scss">
      .map-view-container{
          height: 75vh;
      }

  </style>

